import {Button} from '../Button';
import {CountBadge} from '../CountBadge';
import {Icon} from '../Icon';
import {Popover, PopoverContent, PopoverTrigger} from '../Popover';

import type {FC, ReactNode} from 'react';

export interface ListFilterTriggerProps {
  buttonLabel: string;
  activeCount: number;
  disabled?: boolean;
  align?: 'start' | 'center' | 'end';
  children: ReactNode;
}

export const ListFilterTrigger: FC<ListFilterTriggerProps> = ({
  buttonLabel,
  activeCount,
  disabled = false,
  align = 'end',
  children
}) => {
  const active = activeCount > 0;

  return (
    <Popover>
      <PopoverTrigger
        render={
          <Button variant="secondary" disabled={disabled} icon={<Icon name="filter" />}>
            {buttonLabel}
            {active && <CountBadge variant="brand" count={activeCount} />}
          </Button>
        }
      />
      <PopoverContent className="w-64 p-0" align={align}>
        {children}
      </PopoverContent>
    </Popover>
  );
};
